import React from 'react';
import PropTypes from 'prop-types';
import {
  LoadingToaster, SuccessToaster, FailedToaster, ConfirmationToaster,
} from '.';

const ToasterState = {
  hidden: 'HIDDEN',
  confirming: 'CONFIRMING',
  loading: 'LOADING',
  success: 'SUCCESS',
  failed: 'FAILED',
};

class Toaster extends React.Component {
  static propTypes = {
    toasterState: PropTypes.string,
    toasterText: PropTypes.string,
    onConfirm: PropTypes.func,
    confirmText: PropTypes.string,
    onDismiss: PropTypes.func,
    dismissText: PropTypes.string,
    isAdmin: PropTypes.bool,
    confirmationIcon: PropTypes.string,
  };

  static defaultProps = {
    toasterState: ToasterState.hidden,
    isAdmin: false,
  };

  render() {
    const {
      toasterState,
      toasterText,
      onConfirm,
      confirmText,
      onDismiss,
      dismissText,
      isAdmin,
      confirmationIcon,
    } = this.props;

    let toaster = null;
    if (toasterState === ToasterState.loading) {
      toaster = (<LoadingToaster text={toasterText} />);
    } else if (toasterState === ToasterState.success) {
      toaster = (<SuccessToaster text={toasterText} onDismiss={onDismiss} />);
    } else if (toasterState === ToasterState.failed) {
      toaster = (
        <FailedToaster
          text={toasterText}
          onDismiss={onDismiss}
          dismissText={dismissText}
          isAdmin={isAdmin}
        />
      );
    } else if (toasterState === ToasterState.confirming) {
      toaster = (
        <ConfirmationToaster
          text={toasterText}
          onConfirm={onConfirm}
          confirmText={confirmText}
          onDismiss={onDismiss}
          dismissText={dismissText}
          icon={confirmationIcon}
        />
      );
    }

    return toaster;
  }
}

export default Toaster;
